import TextContentResourceModel from '../../generated/types/model/resource/TextContentResourceModel';

export default class TextContentResourceViewModel extends TextContentResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
